// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.Elements_color__2IYz5.Elements_isGreen__5FQWs {\n  color: #52c41a; }\n\n.Elements_color__2IYz5.Elements_isRed__LFQkL {\n  color: #fa541c; }\n\n.Elements_color__2IYz5.Elements_isWarning__1GhgQ {\n  color: #fa8c16; }\n\n.Elements_color__2IYz5.Elements_isBlue__3hg_p {\n  color: #1890ff; }\n\n.Elements_notInitDataContent__2hLPO {\n  font-size: 20px;\n  color: #262626;\n  font-weight: 600;\n  text-align: center; }\n  .Elements_notInitDataContent__2hLPO .anticon {\n    color: black;\n    font-size: 64px;\n    padding: 8px; }\n  .Elements_notInitDataContent__2hLPO p {\n    margin-top: 16px;\n    margin-bottom: 0; }\n", ""]);
// Exports
exports.locals = {
	"color": "Elements_color__2IYz5",
	"isGreen": "Elements_isGreen__5FQWs",
	"isRed": "Elements_isRed__LFQkL",
	"isWarning": "Elements_isWarning__1GhgQ",
	"isBlue": "Elements_isBlue__3hg_p",
	"notInitDataContent": "Elements_notInitDataContent__2hLPO"
};
module.exports = exports;
